// import request from '@/utils/axios'
// import qs from 'qs'

// export function getCourseTypeInfo(params){
//     let postData = qs.stringify(params)
//     return request({
//       url: '/api/manager/courseType/getCourseTypeList',
//       method: 'get',
//       data:postData
//     })
//   }

//   export function addCourseType(params){
//     let postData = qs.stringify(params)
//     return request({
//       url: '/api/manager/courseType/addCourseType',
//       method: 'post',
//       data:postData
//     })
//   }

//   export function updateCourseType(params){
//     let postData = qs.stringify(params)
//     return request({
//       url: '/api/manager/courseType/editCourseType',
//       method: 'post',
//       data:postData
//     })
//   }

//   export function deleteCourseType(params){
//     let postData = qs.stringify(params)
//     return request({
//       url: '/api/manager/courseType/deleteCourseTypeById',
//       method: 'post',
//       data:postData
//     })
//   }

import request from '@/utils/axios'
import qs from 'qs'

/**
 * 获取班级类型列表
 * @param {*} params 
 */
export function getClasstypes(param) {
    // let data = qs.stringify(params)
    return request({
        url: '/api/manager/classtype/classtypes',
        method: 'get',
        params: param
    })
}

/**
 * 获取格式化的班级类型列表
 * @param {}} param 
 */
export function getFormatClassTypes(param) {
    return request({
        url: '/api/manager/classtype/formatclasstypes',
        method: 'get',
        params: param
    })
}

export function getAllClassTypes(param) {
    return request({
        url: '/api/manager/classtype/allclasstypes',
        method: 'get',
        params: param
    })
}

/**
 * 删除指定id的班级类型
 * @param {*} id 
 */
export function deleteClasstype(id) {
    return request({
        url: '/api/manager/classtype/' + id,
        method: 'delete'
    })
}

/**
 * 添加班级类型
 * @param {}} param 
 */
export function addClasstype(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/classtype',
        method: 'post',
        data: data
    })
}

/**
 * 修改班级类型
 * @param {}} param 
 */
export function editClasstype(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/classtype',
        method: 'put',
        data: data
    })
}

/**
 * 获取全部班级
 * @param {}} param 
 */
 export function allclasstypes(param) {
    return request({
        url: '/api/manager/classtype/allclasstypes',
        method: 'get',
        params: param
    })
}

/**
 * 获取班级学生
 * @param {}} param 
 */
 export function getAllStudentsByClassId(param) {
    return request({
        url: '/api/manager/student/getAllStudentsByClassId',
        method: 'get',
        params: param
    })
}

/**
 * 班级添加多个学员
 * @param {}} param 
 */
 export function addClassAndStudents(param) {
    let data = qs.stringify(param)
    return request({
        url: '/api/manager/studentandclasstype/addClassAndStudents',
        method: 'post',
        data: data
    })
}